import { render, staticRenderFns } from "./inviteoauth.vue?vue&type=template&id=52dca43c&scoped=true&"
import script from "./inviteoauth.vue?vue&type=script&lang=js&"
export * from "./inviteoauth.vue?vue&type=script&lang=js&"
import style0 from "./inviteoauth.vue?vue&type=style&index=0&id=52dca43c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dca43c",
  null
  
)

export default component.exports